import { administrationRequests } from "api/administrationApi";
import React from "react";
import { AutocompleteInput, ReferenceInput, TextInput } from "react-admin";

const CandidateStudentsFilters = [
  <TextInput
    label="Входящ номер"
    source="admissionNumber"
    alwaysOn
  />,
  <TextInput
    label="ЕГН"
    source="personId"
    alwaysOn
  />,
  <TextInput
    label="Име"
    source="firstName"
    alwaysOn
  />,
  <TextInput
    label="Презиме"
    source="secondName"
    alwaysOn
  />,
  <TextInput
    label="Фамилия"
    source="lastName"
    alwaysOn
  />,
  <ReferenceInput
    source="residenceCountryId"
    reference={administrationRequests.getCountriesSelect()}
    alwaysOn
  >
    <AutocompleteInput
      filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
      label="Държава"
      optionText="nameBg"
    />
  </ReferenceInput>,
];

export default CandidateStudentsFilters;
